/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Checkbox } from '@coursera/coursera-ui';

import _t from 'i18n!nls/enterprise-ui';

type SelectTableHeaderProps = {
  numberOfSelectedRows: number;
  totalNumberOfRows: number;
  selectAll: boolean;
  onHeaderSelectChange: (selectAll: boolean) => void;
  actionBtns: JSX.Element[];
};

export const SelectTableHeader = ({
  numberOfSelectedRows,
  totalNumberOfRows,
  selectAll,
  actionBtns,
  onHeaderSelectChange,
}: SelectTableHeaderProps) => {
  const indeterminate = !selectAll && numberOfSelectedRows > 0 && numberOfSelectedRows !== totalNumberOfRows;
  const numSelected = selectAll ? totalNumberOfRows : numberOfSelectedRows;
  const styles = {
    container: css({
      backgroundColor: 'var(--cds-color-blue-700)',
      height: 52,
      position: 'absolute',
      width: '100%',
      top: 0,
      display: 'flex',
      justifyContent: 'space-between',
    }),
    checkboxWrapper: css({
      width: 55,
      padding: 11,
    }),
    selectedCount: css({
      fontSize: 14,
      color: 'var(--cds-color-neutral-primary-invert)',
      fontWeight: 800,
      padding: 11,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }),
    flex: css({ display: 'flex', alignItems: 'center' }),
  };
  const handleCheckboxChange = () => {
    if (selectAll || numberOfSelectedRows > 0) {
      onHeaderSelectChange(false);
    } else {
      onHeaderSelectChange(true);
    }
  };
  return (
    <div css={styles.container}>
      <div css={styles.flex}>
        <div css={styles.checkboxWrapper}>
          <Checkbox
            indeterminate={indeterminate}
            checkedHoverColor="var(--cds-color-white-0)"
            checkedColor="var(--cds-color-white-0)"
            uncheckedColor="var(--cds-color-white-0)"
            uncheckedHoverColor="var(--cds-color-white-0)"
            checked={selectAll || numberOfSelectedRows === totalNumberOfRows}
            onChange={handleCheckboxChange}
          />
        </div>
        <span css={styles.selectedCount}>
          <FormattedMessage message={_t('{count} selected')} count={numSelected.toString()} />
        </span>
      </div>
      <div css={styles.flex}>{actionBtns.map((ActionButton) => ActionButton)}</div>
    </div>
  );
};

type WithSelectProps = SelectTableHeaderProps & {
  showSelectTableHeader: boolean;
};

export const withSelectTableHeader = <TableComponentProps extends {}>(
  TableComponent: React.ComponentType<TableComponentProps>
): React.ComponentType<WithSelectProps & TableComponentProps> => {
  const componentName = TableComponent.displayName || TableComponent.name;
  return class extends React.Component<TableComponentProps & WithSelectProps> {
    static displayName = componentName + 'withSelectTableHeader';

    render() {
      const { showSelectTableHeader } = this.props;
      return (
        <div css={{ position: 'relative' }}>
          {/* @ts-expect-error TS2322: Type TableComponentProps is not assignable to type `IntrinsicAttributes & LibraryManagedAttributes<ComponentType<TableComponentProps>, TableComponentProps>`. */}
          <TableComponent {...(this.props as TableComponentProps)} />
          {showSelectTableHeader && <SelectTableHeader {...(this.props as SelectTableHeaderProps)} />}
        </div>
      );
    }
  };
};
